import React from 'react';
import { HeroVariant32 } from '../components/HeroVariant32';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage32() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1609">
      <Navigation data-id="element-1610" />
      <main data-id="element-1611">
        <HeroVariant32 data-id="element-1612" />
        <WhyUs data-id="element-1613" />
        <Services data-id="element-1614" />
        <FAQ data-id="element-1615" />
        <Testimonials data-id="element-1616" />
        <Consultation data-id="element-1617" />
      </main>
      <Footer data-id="element-1618" />
      <CookieBanner data-id="element-1619" />
      <FloatingContact data-id="element-1620" />
    </div>;
}